import script from "./WelcomeScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeScreen.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeScreen.vue?vue&type=style&index=0&id=dc21a6c6&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc21a6c6"]])

export default __exports__